import { motion, useMotionValue, useTransform, useSpring } from 'framer-motion'

export function with3DTilt(Component) {
  return function WrappedComponent(props) {
    const x = useMotionValue(0.5)
    const y = useMotionValue(0.5)

    // Increased tilt range for a more exaggerated effect
    const rotateX = useTransform(y, [0, 1], [-40, 80])
    const rotateY = useTransform(x, [0, 1], [0, 80])

    // Smooth spring effect with lower stiffness & higher damping for jello effect
    const animatedRotateX = useSpring(rotateX, {
      stiffness: 150,
      damping: 12,
      mass: 1.5, // Adds slight inertia effect
    })

    const animatedRotateY = useSpring(rotateY, {
      stiffness: 150,
      damping: 12,
      mass: 1.5,
    })

    // Scale effect to add a slight bounce
    const scale = useSpring(useTransform(y, [0, 1], [1, 1.1]), {
      stiffness: 250,
      damping: 10,
    })

    const handleMove = (event) => {
      const rect = event.currentTarget.getBoundingClientRect()
      const clientX = event.clientX || (event.touches && event.touches[0]?.clientX)
      const clientY = event.clientY || (event.touches && event.touches[0]?.clientY)

      if (clientX && clientY) {
        const mouseX = clientX - rect.left
        const mouseY = clientY - rect.top

        x.set(mouseX / rect.width)
        y.set(mouseY / rect.height)
      }
    }

    return (
      <motion.div
        {...props}
        style={{
          ...props.style,
          rotateX: animatedRotateX,
          rotateY: animatedRotateY,
          scale: scale,
          transformOrigin: 'center',
        }}
        onMouseMove={handleMove}
        onTouchMove={handleMove}
        onMouseLeave={() => {
          x.set(0.5)
          y.set(0.5)
        }}
        onTouchEnd={() => {
          x.set(0.5)
          y.set(0.5)
        }}
      >
        <Component {...props} />
      </motion.div>
    )
  }
}
